<div class="dd">
  <button type="button" class="dd-close" aria-label="Close" [disabled]="paying" (click)="close()">×</button>

  <!-- Doctor details (Overview / Available Slots) -->
  <ng-container *ngIf="step === 'details'">
    <header class="dd-head">
      <img *ngIf="doctor.profilepic_url" class="dd-avatar dd-avatar-img" [src]="doctor.profilepic_url" [alt]="doctor.name" />
      <div *ngIf="!doctor.profilepic_url" class="dd-avatar">{{ initials(doctor.name) }}</div>

      <div class="dd-head-info">
        <div class="dd-title-row">
          <h2>{{ doctor.name }}</h2>
          <span class="dd-chip dd-chip-spec">{{ doctor.specialty | uppercase }}</span>
          <span class="dd-chip dd-chip-code">{{ doctor.doctor_code }}</span>
        </div>
        <div class="dd-specs" *ngIf="doctor.specializations?.length">{{ doctor.specializations!.join(', ') }}</div>
        <div class="dd-meta">
          {{ doctor.hospital }}<span *ngIf="doctor.experience_label"> · {{ doctor.experience_label }} experience</span>
        </div>
      </div>

      <!-- <div class="dd-head-action" *ngIf="activeTab === 'overview'">
        <span class="dd-avail" *ngIf="doctor.available_today">Available today</span>
        <div class="dd-fee">{{ doctor.fee_symbol }}{{ doctor.consultation_fee }}</div>
        <button type="button" class="dd-btn dd-btn-primary" (click)="openTab('slots')">Book Appointment</button>
      </div> -->
    </header>

    <nav class="dd-tabs" role="tablist">
      <button type="button" role="tab" [class.active]="activeTab === 'overview'" [attr.aria-selected]="activeTab === 'overview'" (click)="openTab('overview')">Overview</button>
      <button type="button" role="tab" [class.active]="activeTab === 'slots'" [attr.aria-selected]="activeTab === 'slots'" (click)="openTab('slots')">Available Slots</button>
    </nav>

    <!-- Overview -->
    <section class="dd-body" *ngIf="activeTab === 'overview'">
      <div class="dd-two-col">
        <div>
          <h3>About Doctor</h3>
          <p class="dd-text">{{ doctor.bio || '—' }}</p>
          <ng-container *ngIf="doctor.education?.length">
            <h3 class="dd-mt">Education</h3>
            <p class="dd-text">{{ doctor.education!.join(', ') }}</p>
          </ng-container>
        </div>
        <div>
          <h3>Clinic Address</h3>
          <p class="dd-text">{{ doctor.hospital }}<br *ngIf="doctor.address" />{{ doctor.address }}</p>
          <ng-container *ngIf="doctor.languages?.length">
            <h3 class="dd-mt">Languages</h3>
            <p class="dd-text">{{ doctor.languages!.join(', ') }}</p>
          </ng-container>
        </div>
      </div>

      <!-- <ng-container *ngIf="doctor.specializations?.length">
        <h3 class="dd-mt">Specializations</h3>
        <div class="dd-pills"><span class="dd-pill" *ngFor="let s of doctor.specializations">{{ s }}</span></div>
      </ng-container> -->

      <!-- <ng-container *ngIf="doctor.education?.length">
        <h3 class="dd-mt">Education</h3>
        <p class="dd-text">{{ doctor.education!.join(', ') }}</p>
      </ng-container> -->
    </section>

    <!-- Available Slots -->
    <section class="dd-body" *ngIf="activeTab === 'slots'">
      <div class="dd-slotcard">
        <div class="dd-slot-top">
          <h3>Pick a Time Slot</h3>
          <div class="dd-feebox">CONSULTATION FEE <b>{{ doctor.fee_symbol }}{{ doctor.consultation_fee }}</b></div>
        </div>

        <div class="dd-state" *ngIf="loadingSlots">Loading available slots…</div>
        <div class="dd-state dd-state-err" *ngIf="slotsError">
          Couldn’t load slots. <button type="button" class="dd-link" (click)="loadSlots()">Retry</button>
        </div>
        <div class="dd-state" *ngIf="slotsLoaded && !slotsError && slotDays.length === 0">No slots available for this doctor right now.</div>

        <ng-container *ngIf="slotDays.length > 0">
          <div class="dd-days" role="tablist">
            <button type="button" role="tab" class="dd-day" *ngFor="let d of slotDays; let i = index"
                    [class.active]="i === selectedDayIdx" [attr.aria-selected]="i === selectedDayIdx" (click)="selectDay(i)">
              <span class="dd-day-name">{{ dayLabel(d, i) || (d.date | date:'EEE MMM d') }}</span>
              <span class="dd-day-count" [class.none]="availableCount(d) === 0">{{ availableCount(d) }} Slots Available</span>
            </button>
          </div>

          <div class="dd-state" *ngIf="groups.length === 0">No slots on this day.</div>
          <div class="dd-group" *ngFor="let g of groups">
            <div class="dd-group-title">{{ g.title }} <span>({{ g.slots.length }} slots)</span></div>
            <div class="dd-slots">
              <button type="button" class="dd-slot" *ngFor="let s of g.slots"
                      [class.on]="selectedSlot?.id === s.id" [disabled]="!s.available" [attr.title]="s.available ? null : s.reason" (click)="selectSlot(s)">{{ s.label }}</button>
            </div>
          </div>
        </ng-container>
      </div>
    </section>
  </ng-container>

  <!-- ═══ STEP 2 · Billing details ═══ -->
  <div class="dd-billing" *ngIf="step === 'billing'">
    <div class="dd-bill-left">
      <h2><button type="button" class="dd-back" aria-label="Back to slots" (click)="backToSlots()" [disabled]="paying">‹</button> Billing Details</h2>

      <div class="dd-grid">
        <div class="dd-field">
          <label for="bfn">First Name <span class="req">*</span></label>
          <input id="bfn" type="text" [(ngModel)]="form.first_name" [class.invalid]="submitted && !form.first_name.trim()" />
          <small class="err" *ngIf="submitted && !form.first_name.trim()">First name is required</small>
        </div>
        <div class="dd-field">
          <label for="bln">Last Name <span class="req">*</span></label>
          <input id="bln" type="text" [(ngModel)]="form.last_name" [class.invalid]="submitted && !form.last_name.trim()" />
          <small class="err" *ngIf="submitted && !form.last_name.trim()">Last name is required</small>
        </div>
        <div class="dd-field">
          <label for="bph">Phone <span class="req">*</span> <i class="bi bi-lock-fill lock"></i></label>
          <input id="bph" type="text" [value]="form.phone" readonly />
        </div>
        <div class="dd-field">
          <label for="bem">Email Address <span class="req">*</span> <i class="bi bi-lock-fill lock"></i></label>
          <input id="bem" type="text" [value]="form.email" readonly />
        </div>
        <div class="dd-field dd-span2">
          <label for="bco">Country / Region <span class="req">*</span></label>
          <input id="bco" type="text" [value]="form.country" readonly />
        </div>
      </div>

      <div class="dd-sub">Patient details</div>
      <div class="dd-grid">
        <div class="dd-field">
          <select aria-label="Booking for" [(ngModel)]="form.booking_for">
            <option>Myself</option>
            <option>Someone else</option>
          </select>
        </div>
        <div class="dd-field">
          <input type="text" aria-label="Reason for visit" placeholder="Reason for visit (optional)" maxlength="200" [(ngModel)]="form.reason" />
        </div>
      </div>
    </div>

    <div class="dd-bill-right">
      <h2>Your Payment</h2>
      <div class="dd-paycard">
        <div class="dd-pay-top">
          <div>
            <b>Slot for {{ selectedSlot?.label }}</b>
            <div class="dd-pay-sub">{{ doctor.name }} · {{ doctor.doctor_code }}</div>
          </div>
          <b>{{ doctor.fee_symbol }}{{ doctor.consultation_fee | number:'1.2-2' }}</b>
        </div>

        <div class="dd-coupon">
          <input type="text" aria-label="Coupon code" placeholder="Enter coupon code" [(ngModel)]="coupon" (keydown.enter)="applyCoupon()" />
          <button type="button" class="dd-btn dd-btn-ghost" (click)="applyCoupon()" [disabled]="!coupon.trim()">Apply</button>
        </div>
        <small class="dd-coupon-msg" *ngIf="couponMsg">{{ couponMsg }}</small>

        <div class="dd-sub">Price Details</div>
        <div class="dd-state dd-state-err" *ngIf="pricingError">
  Couldn’t load pricing.
  <button type="button" class="dd-link" (click)="loadPricing()">Retry</button>
</div>

<ng-container *ngIf="pricing">
  <!-- Dynamic line items -->
  <div class="dd-line" *ngFor="let item of pricing.line_items">
    <span>{{ item.label }}</span>
    <span>
      ₹{{ item.amount | number:'1.2-2' }}
    </span>
  </div>

  <!-- Discount, if applicable -->
  <div class="dd-line" *ngIf="pricing.discount">
    <span>Discount</span>
    <span>
      −₹{{ pricing.discount | number:'1.2-2' }}
    </span>
  </div>

  <!-- Total -->
  <div class="dd-total">
    <span>{{ pricing.totals.final_amount_label || 'Total Payable' }}</span>
    <span>
      ₹{{ pricing.totals.final_amount | number:'1.2-2' }}
    </span>
  </div>
</ng-container>

        <div class="dd-online">Online Payment</div>
        <p class="dd-pay-note"><b>Pay by Razorpay</b> — securely by UPI, credit or debit card. We only support online payments.</p>

        <div class="dd-actions">
          <button type="button" class="dd-btn dd-btn-ghost" (click)="close()" [disabled]="paying">Cancel</button>
          <button type="button" class="dd-btn dd-btn-primary" (click)="bookSlot()" [disabled]="paying || !pricing">
            {{ paying ? 'Processing…' : 'Book Slot' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- STEP 3 · Appointment confirmed -->
  <div class="dd-confirm" *ngIf="step === 'confirmed' && confirmation">
    <div class="dd-tick"><i class="bi bi-check-lg"></i></div>
    <h2>Appointment confirmed</h2>
    <p class="dd-text">Payment of ₹{{ confirmation.amount_paid | number:'1.2-2' }} received. A confirmation has been sent to your phone and email.</p>

    <div class="dd-summary">
      <div><span>Doctor</span><b>{{ doctor.name }} · {{ doctor.doctor_code }}</b></div>
      <div><span>Date &amp; time</span><b>{{ slotDays[selectedDayIdx]?.date | date:'EEE, dd MMM y' }} · {{ selectedSlot?.label }}</b></div>
      <div><span>Visit type</span><b>In-clinic · {{ doctor.hospital }}</b></div>
      <div><span>Booking ID</span><b>{{ confirmation.booking_id }}</b></div>
    </div>

    <div class="dd-actions dd-actions-center">
      <!-- <button type="button" class="dd-btn dd-btn-ghost" (click)="addToCalendar()">Add to Calendar</button> -->
      <button type="button" class="dd-btn dd-btn-primary" (click)="close()">View My Appointments</button>
    </div>
  </div>
</div>